import 'underscore';

var initialState = {
    charityId: null,
    forceFreeShipping: false,
    name: null,
    description: null,
    isSchenkerPaidBySchenker: false
};

function isSchenkerPaying(campaignCode) {
    const code = campaignCode.toUpperCase();
    return (
        code == 'MHO20' ||
        code == 'MHF20' ||
        code == 'MH20' ||
        code == 'MHTEST' ||
        code == 'MHTESTF'
    );
}

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'RESET_CHARITY':
            return _.assign({}, initialState);
        case 'SET_CHARITY':
            return _.assign({}, state, {
                charityId: action.charity.charityId,
                forceFreeShipping: action.charity.forceFreeShipping,
                name: action.charity.name,
                description: action.charity.description,
                isSchenkerPaidBySchenker: isSchenkerPaying(action.campaignCode),
                allowZeroDayAuctions: action.charity.allowZeroDayAuctions
            });

        default:
            return state;
    }
};
